import React from 'react';
import { PageHero } from '../components/PageHero';
export function AccessibilityStatement() {
  return <div className="animate-fade-in-up" data-id="element-241">
      <PageHero title="Accessibility Statement" subtitle="Last Updated: February 9, 2026" data-id="element-242" />
      <section className="py-16 md:py-24 bg-white" data-id="element-243">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12 text-teal/80 leading-relaxed" data-id="element-244">
          <div className="space-y-4" data-id="element-245">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-246">
              Our Commitment to Accessibility
            </h2>
            <p data-id="element-247">
              At Arrive Psychotherapy & Wellness, we are committed to ensuring
              that our services and website are accessible to everyone,
              including people with disabilities. We believe that mental health
              support should be available to all individuals, and we strive to
              remove barriers to accessing our services.
            </p>
            <p data-id="element-248">
              This accessibility statement outlines our ongoing efforts to meet
              or exceed the requirements of the Accessibility for Ontarians with
              Disabilities Act (AODA) and the Web Content Accessibility
              Guidelines (WCAG) 2.1 Level AA standards.
            </p>
          </div>

          <div className="space-y-4" data-id="element-249">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-250">
              Accessibility of Our Services
            </h2>

            <h3 className="text-xl font-medium text-sage" data-id="element-251">
              Benefits of Online Therapy:
            </h3>
            <ul className="list-disc pl-5 space-y-2" data-id="element-252">
              <li data-id="element-253">
                <strong data-id="element-254">No physical barriers:</strong> Eliminates the need to
                travel to an office
              </li>
              <li data-id="element-255">
                <strong data-id="element-256">Flexible environment:</strong> Participate from the
                comfort of your own home
              </li>
              <li data-id="element-257">
                <strong data-id="element-258">Assistive technology compatible:</strong> Works with
                screen readers, voice recognition software, and other assistive
                technologies
              </li>
              <li data-id="element-259">
                <strong data-id="element-260">Reduced sensory overwhelm:</strong> Control your
                environment (lighting, noise level, etc.)
              </li>
              <li data-id="element-261">
                <strong data-id="element-262">Communication flexibility:</strong> Option to use chat
                or phone if video is challenging
              </li>
            </ul>

            <h3 className="text-xl font-medium text-sage mt-4" data-id="element-263">
              Platform Accessibility Features:
            </h3>
            <ul className="list-disc pl-5 space-y-2" data-id="element-264">
              <li data-id="element-265">Screen reader compatible</li>
              <li data-id="element-266">Keyboard navigation support</li>
              <li data-id="element-267">Adjustable text size and contrast</li>
              <li data-id="element-268">Compatible with most assistive technologies</li>
            </ul>

            <h3 className="text-xl font-medium text-sage mt-4" data-id="element-269">
              Service Accommodations:
            </h3>
            <ul className="list-disc pl-5 space-y-2" data-id="element-270">
              <li data-id="element-271">
                Sessions can be conducted via video, phone, or secure messaging
                (as clinically appropriate)
              </li>
              <li data-id="element-272">
                Written materials can be provided in alternative formats upon
                request
              </li>
              <li data-id="element-273">Flexible session pacing to accommodate processing needs</li>
              <li data-id="element-274">Clear, jargon-free language in all communications</li>
              <li data-id="element-275">Flexible appointment times</li>
              <li data-id="element-276">Reminders sent via email and/or SMS</li>
              <li data-id="element-277">Breaks during sessions if needed</li>
            </ul>
          </div>

          <div className="space-y-4" data-id="element-278">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-279">
              Website Accessibility
            </h2>

            <h3 className="text-xl font-medium text-sage" data-id="element-280">
              Current Accessibility Features:
            </h3>
            <div className="grid md:grid-cols-3 gap-6 mt-4" data-id="element-281">
              <div className="bg-neutral-soft p-4 rounded-lg" data-id="element-282">
                <h4 className="font-medium text-teal mb-2" data-id="element-283">
                  Visual Accessibility
                </h4>
                <ul className="list-disc pl-4 text-sm space-y-1" data-id="element-284">
                  <li data-id="element-285">Clean, simple design with generous white space</li>
                  <li data-id="element-286">
                    High contrast between text and background (minimum 4.5:1
                    ratio)
                  </li>
                  <li data-id="element-287">Readable fonts (Montserrat) at appropriate sizes</li>
                  <li data-id="element-288">Resizable text without loss of functionality</li>
                </ul>
              </div>
              <div className="bg-neutral-soft p-4 rounded-lg" data-id="element-289">
                <h4 className="font-medium text-teal mb-2" data-id="element-290">Navigation</h4>
                <ul className="list-disc pl-4 text-sm space-y-1" data-id="element-291">
                  <li data-id="element-292">Clear, consistent navigation structure</li>
                  <li data-id="element-293">Descriptive page titles and headings</li>
                  <li data-id="element-294">Keyboard-accessible navigation</li>
                  <li data-id="element-295">Skip-to-content links</li>
                  <li data-id="element-296">Descriptive link text</li>
                </ul>
              </div>
              <div className="bg-neutral-soft p-4 rounded-lg" data-id="element-297">
                <h4 className="font-medium text-teal mb-2" data-id="element-298">Content</h4>
                <ul className="list-disc pl-4 text-sm space-y-1" data-id="element-299">
                  <li data-id="element-300">Clear, plain language without unnecessary jargon</li>
                  <li data-id="element-301">Proper heading hierarchy (H1, H2, H3, etc.)</li>
                  <li data-id="element-302">Alt text for all images</li>
                  <li data-id="element-303">Fast loading times</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="space-y-4" data-id="element-304">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-305">
              Feedback and Accommodation Requests
            </h2>
            <p data-id="element-306">If you:</p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-307">
              <li data-id="element-308">
                Encounter accessibility barriers on our website or in accessing
                our services
              </li>
              <li data-id="element-309">Have suggestions for how we can improve</li>
              <li data-id="element-310">Need specific accommodations to access therapy services</li>
            </ul>
            <p className="mt-4" data-id="element-311">Please contact us: jess@arrivetherapy.ca</p>
          </div>

          <div className="space-y-4" data-id="element-312">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-313">
              Requesting Accommodations
            </h2>
            <ul className="list-disc pl-5 space-y-2" data-id="element-314">
              <li data-id="element-315">
                Contact us before your first session (or at any time) to discuss
                your needs
              </li>
              <li data-id="element-316">Describe what accommodations would be helpful</li>
              <li data-id="element-317">Collaborate with us to find solutions that work for you</li>
              <li data-id="element-318">Provide feedback after accommodations are implemented</li>
            </ul>
            <p className="font-medium text-teal" data-id="element-319">
              We will work with you to provide accommodations in a timely manner
              at no additional cost to you.
            </p>

            <h3 className="text-xl font-medium text-sage mt-4" data-id="element-320">
              Examples of accommodations we can provide:
            </h3>
            <ul className="list-disc pl-5 space-y-2" data-id="element-321">
              <li data-id="element-322">
                Alternative communication methods (phone instead of video, etc.)
              </li>
              <li data-id="element-323">Flexible session formats or pacing</li>
              <li data-id="element-324">Written materials in alternative formats</li>
              <li data-id="element-325">Additional time for intake forms</li>
              <li data-id="element-326">Reminders in your preferred format</li>
            </ul>
          </div>

          <div className="space-y-4" data-id="element-327">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-328">
              Accessible Formats and Communication Supports
            </h2>
            <p data-id="element-329">
              All documents, forms, and communications can be provided in
              accessible formats upon request, including:
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-330">
              <li data-id="element-331">Large print</li>
              <li data-id="element-332">Plain text email</li>
              <li data-id="element-333">Screen reader-compatible PDFs</li>
              <li data-id="element-334">Simplified language</li>
              <li data-id="element-335">Audio format</li>
            </ul>
            <p className="text-sm italic" data-id="element-336">
              Please allow up to 5 business days for us to provide materials in
              alternative formats.
            </p>
          </div>

          <div className="space-y-4" data-id="element-337">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-338">
              Accessibility Standards and Compliance
            </h2>
            <p data-id="element-339">
              We are committed to meeting our obligations under the
              Accessibility for Ontarians with Disabilities Act, 2005 (AODA) and
              our website aims to meet or exceed Web Content Accessibility
              Guidelines (WCAG) 2.1 Level AA standards.
            </p>
          </div>

          <div className="space-y-4 border-t border-sage/20 pt-8" data-id="element-340">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-341">
              Contact Us
            </h2>
            <p data-id="element-342">
              For accessibility questions, accommodation requests, or feedback:
            </p>
            <p data-id="element-343">Jessica Ruppert, MA, RP (Qualifying), jess@arrivetherapy.ca</p>
          </div>
        </div>
      </section>
    </div>;
}